import TagManager from 'react-gtm-module';

const dataLayer = {
  triggerEvent: (event: string) => {
    const dataLayerArgs = {
      dataLayer: {
        event,
      },
    };
    TagManager.dataLayer(dataLayerArgs);
  },
  triggerPageViewEvent: (page: string, step: number) => {
    const dataLayerArgs = {
      dataLayer: {
        event: 'pageview',
        page,
        step,
      },
    };
    TagManager.dataLayer(dataLayerArgs);
  },
  triggerUserErrorEvent: (name: string, description: string, flow: string) => {
    const dataLayerArgs = {
      dataLayer: {
        event: 'error',
        type: 'user_error',
        name,
        description,
        fluxo: flow,
      },
    };
    TagManager.dataLayer(dataLayerArgs);
  },
};

const loginDataLayer = {
  triggerEvent: () => {
    dataLayer.triggerEvent('validarLogin');
  },
  triggerPageViewEvent: (subPage: string, step: number) => {
    dataLayer.triggerPageViewEvent(`/pagevirtual/login/${subPage}`, step);
  },
  triggerUserErrorEvent: (name: string, description: string) => {
    dataLayer.triggerUserErrorEvent(name, description, 'Validação de Login');
  },
  inactiveUserSubPage: (memberStatus: string | undefined) => {
    let subPage = '';
    switch (memberStatus) {
      case 'DECEASED':
        subPage = 'falecido';
        break;
      case 'CANCELLED':
        subPage = 'conta-cancelada';
        break;
      default:
        subPage = 'conta-suspensa';
        break;
    }
    return subPage;
  },
};

export { dataLayer, loginDataLayer };
